import store from "@/store";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetAvailableLanguagesResponse extends ApiGenericResponse {
    availableLanguages: string[];
    constructor(response: AxiosResponse) {
        super(response);
        this.availableLanguages = [];
        let blacklistedLanguages = store.state.application.startupData.blacklistedLanguages;
        if (response.data && response.data.Payload && response.data.Payload.length > 0) {
            response.data.Payload.forEach((e) => {
                if (!blacklistedLanguages || !blacklistedLanguages.includes(e)) this.availableLanguages.push(e);
            });
        }
    }
}
